import React from 'react'
import { useTranslation } from 'react-i18next'; // i18next hook'unu ekledik
import "./footer.css"
import Logo from "../../assets/images/thm-logo.png"
import { IoLocationOutline, IoMailOutline } from 'react-icons/io5'

const Footer = () => {
  const { t } = useTranslation(); // Çeviri fonksiyonunu başlattık

  return (
    <div className='footer-container relative overflow-hidden'>
      <div className='footer-top-container relative z-10'>
        <div className='w-[90%] md:mx-[auto]'>
          <img className='md:w-[65%] md:mx-[auto]' src={Logo} alt="THM Investment Logo" />
          <p className='mt-4 text-[#0D0D0D] font-[300]'>
            {t('footer.description')}
          </p>
        </div>

        <div>
          <h3 className='footer-title'>{t('footer.explore')}</h3>
          <div className='flex flex-col'> {/* flex-column Tailwind'de flex-col'dur, düzelttim */}
            <a className='footer-link' href="/about">{t('footer.aboutUs')}</a>
            {/* <a className='footer-link' href="/services">{t('footer.ourServices')}</a>
            <a className='footer-link' href="/our-facility">{t('footer.ourFacility')}</a> */}
          </div>
        </div>

        <div>
          <h3 className='footer-title'>{t('footer.investorInfo')}</h3>
          <div className='flex flex-col'> {/* flex-column -> flex-col */}
            <a className='footer-link' href="/investment-opportunities">{t('footer.investmentOpportunities')}</a>
            <a className='footer-link' href="/investment-incentives">{t('footer.incentives')}</a>
            <a className='footer-link' href="/contact">{t('footer.contactUs')}</a>
          </div>
        </div>

        <div>
          <h3 className='footer-title'>{t('footer.reachOut')}</h3>
          <div className='flex flex-col'> {/* flex-column -> flex-col */}
            {/* <div className='grid grid-cols-8 flex items-center footer-link'>
              <div className='col-span-1 text-2xl text-[#DAA521]'><IoCallOutline /></div>
              <div className='col-span-7'>+90 555 555 55 55</div>
            </div> */}
            <div className='grid grid-cols-8 flex items-center footer-link'>
              <div className='col-span-1 text-2xl text-[#DAA521]'><IoMailOutline /></div>
              <div className='col-span-7'><a href="mailto:info@thminvestment.com" target='_blank' rel="noreferrer" >info@thminvestment.com</a></div>
            </div>
            <div className='grid grid-cols-8 flex items-center footer-link'>
              <div className='col-span-1 text-2xl text-[#DAA521]'><IoLocationOutline /></div>
              <div className='col-span-7'>
                {t('footer.address')}
              </div>
            </div>
          </div>
        </div>

      </div>
      <div className='footer-bottom-container z-10 relative text-center py-[40px] text-[18px] text-[#6B7280] font-[300]'>
        <span>{t('footer.copyright')}</span>
      </div>
    </div>
  )
}

export default Footer;